<template>
	<div
		v-editable="blok"
		class="grid md:grid-flow-col md:grid-cols-[65%_35%] md:grid-rows-2 md:gap-0 gap-4"
	>
		<StoryblokComponent
			v-for="(feature, index) in blok.content"
			:key="feature._uid"
			:blok="feature"
			:class="blockStyles[index]"
		/>
	</div>
</template>

<script setup lang="ts">
import type { BlokColumns } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokColumns;
}

const { blok } = defineProps<Props>();

const blockStyles = [
	"pb-[75%] md:ml-0 md:max-w-[calc(100%-16px)] md:col-start-1 md:col-end-auto md:row-start-1 md:row-end-4",
	"md:pb-[calc(75%-16px)] pb-[60%] md:mb-2 md:col-start-2 md:col-end-auto md:row-start-1 md:row-end-2",
	"md:pb-[calc(75%-16px)] pb-[60%] md:mt-2 md:col-start-2 md:col-end-auto md:row-start-2 md:row-end-3"
];
</script>
